import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';

const messages = [
    "🚀 Hang tight!\nWe’re cooking up some magic for you…",
    "📡 Connecting the dots…\nYour request is on its way!",
    "🎨 Crafting results…\nAdding the finishing touches for you!",
    "🔍 Looking closely…\nGathering all the right details!",
    "🧙 Summoning data spells…\nYour request is in progress!",
    "⏳ Still working…\nThanks for your patience, good things take time!",
    "🌟 Almost there…\nYour changes are being polished to perfection!",
];

interface LoadingMessagesProps {
    simpleMode?: boolean;
    simpleText?: string;
}

const LoadingMessages: React.FC<LoadingMessagesProps> = ({
    simpleMode = false,
    simpleText = "Processing… Please wait",
}) => {
    const [messageIndex, setMessageIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        if (simpleMode) return;

        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setMessageIndex(prev => (prev + 1) % messages.length);
                setFade(true);
            }, 400);
        }, 4000);

        return () => clearInterval(interval);
    }, [simpleMode]);

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(255,255,255,0.7)',
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                pointerEvents: 'auto',
            }}
        >
            <Spin size="default" />
            <div
                style={{
                    marginTop: 24,
                    padding: '16px 24px',
                    borderRadius: 12,
                    background: simpleMode ? 'transparent' : 'rgba(255,255,255,0.9)',
                    boxShadow: simpleMode ? 'none' : '0 4px 12px rgba(0,0,0,0.1)',
                    fontSize: '18px',
                    color: '#333',
                    textAlign: 'center',
                    whiteSpace: 'pre-line',
                    fontWeight: 500,
                    maxWidth: 400,
                    transition: 'opacity 0.4s ease, transform 0.4s ease',
                    opacity: fade ? 1 : 0,
                    transform: fade ? 'translateY(0)' : 'translateY(10px)',
                }}
            >
                {simpleMode ? simpleText : messages[messageIndex]}
            </div>
        </div>
    );
};

export default LoadingMessages;
